import React, { useEffect, useState } from 'react';
import { Modal } from 'antd';
import classnames from 'classnames';
import ErrorIcon from '@web-common/components/UI/Icons/svgs/ErrorSvg';
import { MailActions, useAppSelector, useActions } from '@web-common/state/createStore';
import { apiHolder as api, apis } from 'api';
import IconCard from '@web-common/components/UI/IconCard/index';
import styles from '../mailInfo.module.scss';
import PraiseMailSetting from './Setting';
import PraiseDesc from './PraiseDesc';
import { getIn18Text } from 'api';
import { remWaittingId } from '@web-mail-write/util';
const trackApi = api.api.requireLogicalApi(apis.dataTrackerApiImp);
const mailApi = api.api.requireLogicalApi(apis.mailApiImpl);
const PraiseMail = props => {
    const infoStatus = useAppSelector(state => state.mailReducer.currentMail.status);
    const curAccount = useAppSelector(state => { var _a; return (_a = state.mailReducer.currentMail) === null || _a === void 0 ? void 0 : _a.optSender; });
    const currentMailId = useAppSelector(state => state.mailReducer.currentMail.cid);
    const mailActions = useActions(MailActions);
    const [allMedals, setMedals] = useState([]);
    useEffect(() => {
        mailApi.doGetPraiseMedals().then(setMedals);
    }, []);
    useEffect(() => {
        if (curAccount && !curAccount.isMainAccount) {
            deletePraiseMailConfirm();
        }
    }, [curAccount]);
    const praiseMail = useAppSelector(state => state.mailReducer.currentMail.praiseMail);
    const curMedal = allMedals.find(item => item.id === (praiseMail === null || praiseMail === void 0 ? void 0 : praiseMail.medalId));
    const [winners, setWinners] = useState([]);
    const praiseMailShow = infoStatus === null || infoStatus === void 0 ? void 0 : infoStatus.praiseMailShow;
    const praiseMailSetting = infoStatus === null || infoStatus === void 0 ? void 0 : infoStatus.praiseMailSetting;
    useEffect(() => {
        if (praiseMailShow && !praiseMailSetting && !winners.length && !(curMedal === null || curMedal === void 0 ? void 0 : curMedal.imageUrl) && !(praiseMail === null || praiseMail === void 0 ? void 0 : praiseMail.presentationWords)) {
            mailActions.doPraiseShow(false);
        }
    }, [praiseMailShow, praiseMailSetting]);
    const deletePraiseMailConfirm = () => {
        mailActions.doPraiseShow(false);
        mailActions.doPraiseMailSetting(false);
    };
    const deletePraiseMail = (e) => {
        e.stopPropagation();
        remWaittingId(currentMailId, true);
        Modal.confirm({
            icon: React.createElement(ErrorIcon, { className: "error-icon" }),
            okButtonProps: { danger: true, type: 'default' },
            title: getIn18Text('YAOSHANCHUBIAOYANG'),
            okText: getIn18Text('SHANCHU'),
            cancelText: getIn18Text('QUXIAO'),
            onOk: () => {
                deletePraiseMailConfirm();
                trackApi.track('pcMail_click_writeMail_addPraiseLetterPage_deletePraiseLetter');
            },
            width: 448,
            className: 'im-team',
            centered: true,
        });
    };
    const showSetting = () => {
        mailActions.doPraiseMailSetting(true);
    };
    return (React.createElement("div", { className: classnames([styles.conferenceWrap]), style: { height: praiseMailShow ? 'auto' : 0 } },
        React.createElement("div", { hidden: !praiseMailSetting },
            React.createElement(PraiseMailSetting, Object.assign({ deletePraiseMail: deletePraiseMail }, props))),
        React.createElement("div", { hidden: praiseMailSetting || !praiseMailShow },
            React.createElement("div", { className: classnames([styles.infoItem]), onClick: showSetting },
                React.createElement("span", { className: styles.infoLabel }, getIn18Text('BIAOYANGXIN')),
                React.createElement("span", { className: styles.colonLabel }, ":"),
                React.createElement("div", { className: classnames([styles.conferenceTime, styles.conferenceTimeDesc]) },
                    React.createElement(PraiseDesc, null)),
                React.createElement("div", { className: classnames([styles.btnBox, styles.closeBtn]) },
                    React.createElement("span", { className: classnames([styles.labelBtn, styles.labelCloseBtn]), onClick: deletePraiseMail },
                        React.createElement(IconCard, { className: "dark-invert", type: "close" })))))));
};
export default PraiseMail;
